import CuentaCreate from './CuentaCreate'
export {CuentaCreate}
export default CuentaCreate
